module.exports = __webpack_public_path__ + "resources/more-35ec626e23767c118990cdab7839de52.svg";